import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


// Aktivní/zobrazené komponenty pro jednotlivé sloty
// Její změnou se přepíná aktivní zobrazená komponenta
// Nastavuje se jménem aplikace a jménem slotu, např. { CompName: "BasicMenu", SlotName: "SlotFront" }
const module_VybComp = {

  // initial state
  state: () => ({
    sVybComp: { SlotBack: "", SlotFront: "", SlotTop: "" }
  }),

  // mutations (nastavit/změnit) synchronní
  mutations: {
    //  $store.commit("SET_sVybComp", name);
    SET_sVybComp(state, data) {
      state.sVybComp[data.SlotName] = data.CompName
      //      state.sVybComp = data
    },
  },

  // actions (nastavit/změnit) asynchronní
  actions: {
    //  $store.dispatch('SET_sVybComp',name)
    SET_sVybComp({ commit }, data) {
      commit('SET_sVybComp', data)
    }
  },

  // getters (získat)
  getters: {
    // $store.getters.GET_sVybComp;
    GET_sVybComp(state) {
      return state.sVybComp
    }

  }
}



// Vybrané Lhc
const module_VybLhc = {

  state: () => ({
    sVybLhc: { type: Object, default: null }
  }),

  mutations: {
    SET_sVybLhc(state, data) {
      state.sVybLhc = data
    },
  },

  actions: {
    SET_sVybLhc({ commit }, data) {
      commit('SET_sVybLhc', data)
    }
  },

  getters: {
    GET_sVybLhc(state) {
      return state.sVybLhc
    }

  }
}


// Vybrané Jprl
const module_VybJprl = {

  state: () => ({
    sVybJprl: { JprlID: "", ViewVypis: true, ViewOnMap: true }
  }),

  mutations: {
    SET_sVybJprl(state, data) {
      state.sVybJprl = data
    },
  },

  actions: {
    SET_sVybJprl({ commit }, data) {
      commit('SET_sVybJprl', data)
    }
  },

  getters: {
    GET_sVybJprl(state) {
      return state.sVybJprl
    }

  }
}


// Mapa - nastavení MBR
const module_MapMBR = {

  state: () => ({
    sMapMBR: null
    //sMapMBR: { ref: 'EPSG:3857', xmin: 0, ymin: 0, xmax: 0, ymax: 0 }
  }),

  mutations: {
    SET_sMapMBR(state, data) {
      state.sMapMBR = data
    },
  },

  actions: {
    SET_sMapMBR({ commit }, data) {
      commit('SET_sMapMBR', data)
    }
  },

  getters: {
    GET_sMapMBR(state) {
      return state.sMapMBR
    }

  }
}

// Mapa - nastavení středu výřezu na bod
const module_MapCP = {

  state: () => ({
    sMapCP: null
    //sMapCP: { ref: 'EPSG:3857', xmin: 0, ymin: 0, xmax: 0, ymax: 0 }
  }),

  mutations: {
    SET_sMapCP(state, data) {
      state.sMapCP = data
    },
  },

  actions: {
    SET_sMapCP({ commit }, data) {
      commit('SET_sMapCP', data)
    }
  },

  getters: {
    GET_sMapCP(state) {
      return state.sMapCP
    }

  }
}


// Mapa - dotaz z mapy - typ (rozlišení dotazu), epsg, souřadnice (x.y) a options (cokoliv)
const module_MapQuery = {

  state: () => ({
    sMapQuery: { type: 'basic', epsg: 3857, x: 0, y: 0, options: {} }
  }),

  mutations: {
    SET_sMapQuery(state, data) {
      state.sMapQuery = data
    },
  },

  actions: {
    SET_sMapQuery({ commit }, data) {
      commit('SET_sMapQuery', data)
    }
  },

  getters: {
    GET_sMapQuery(state) {
      return state.sMapQuery
    }

  }
}



// Mapa - dotaz z mapy na jprl
const module_MapQueryJprl = {

  state: () => ({
    sMapQueryJprl: {}
  }),

  mutations: {
    SET_sMapQueryJprl(state, data) {
      state.sMapQueryJprl = data
    },
  },

  actions: {
    SET_sMapQueryJprl({ commit }, data) {
      commit('SET_sMapQueryJprl', data)
    }
  },

  getters: {
    GET_sMapQueryJprl(state) {
      return state.sMapQueryJprl
    }

  }
}


// Mapa - dotaz z mapy na parcelu
const module_MapQueryPar = {

  state: () => ({
    sMapQueryPar: null
  }),

  mutations: {
    SET_sMapQueryPar(state, data) {
      state.sMapQueryPar = data
    },
  },

  actions: {
    SET_sMapQueryPar({ commit }, data) {
      commit('SET_sMapQueryPar', data)
    }
  },

  getters: {
    GET_sMapQueryPar(state) {
      return state.sMapQueryPar
    }

  }
}


// Mapa - přidání vrstvy do mapy, předává se definice vrstvy jako json
const module_MapAddLayer = {

  state: () => ({
    sMapAddLayer: null
  }),

  mutations: {
    SET_sMapAddLayer(state, data) {
      state.sMapAddLayer = data
    },
  },

  actions: {
    SET_sMapAddLayer({ commit }, data) {
      commit('SET_sMapAddLayer', data)
    }
  },

  getters: {
    GET_sMapAddLayer(state) {
      return state.sMapAddLayer
    }

  }
}


export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {

    VybComp: module_VybComp,
    VybLhc: module_VybLhc,
    VybJprl: module_VybJprl,
    MapMBR: module_MapMBR,
    MapCP: module_MapCP,
    MapQuery: module_MapQuery,
    MapQueryJprl: module_MapQueryJprl,
    MapQueryPar: module_MapQueryPar,
    MapAddLayer: module_MapAddLayer,


    //AppCategory: module_AppCategory,


  }


}










)

